export default __webpack_public_path__ + "static/media/18TorreReforma.1fea2347.pdf";